import { jsx as _jsx } from "react/jsx-runtime";
import ReactDOMClient from 'react-dom/client';
import { CapsuleModal } from '../../modal/CapsuleModal';
import { newTheme } from '../../modal/theme';
export function renderModal(capsule, appName, onCloseArg) {
    const container = document.createElement('div');
    const root = ReactDOMClient.createRoot(container);
    const onClose = () => {
        root.unmount();
        container.remove();
        onCloseArg();
    };
    root.render(_jsx(CapsuleModal, { onClose: onClose, capsule: capsule, isOpen: true, appName: appName, theme: newTheme }));
}
